var BarrasHorizontalesEmisionesExtra = function(el, datos, total, callback) {
  var debug = false;

  var altoVisualizacion = 0;

  var n = datos.extras.length;
  var alturaAux = 0;
  switch (n) {
    case 1:
      alturaAux = 170;
      break;
    case 2:
      alturaAux = 320;
      break;
    case 3:
      alturaAux = 520;
      break;
    default:
      break;
  }

  (function() {
    datos.opciones = _.filter(datos.opciones, function(d) {
      return d.valor > 0;
    });
    var config = new Config(0, {
      top: 80,
      right: 10,
      bottom: 100,
      left: 200
    });
    var estilos = config.getEstilos();
    var contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      var barras = config.getBarrasHorizontales();
      var svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", "0 0 " + config.getAncho() + " " + 0);
      var texto = svg
        .append("text")
        .style(estilos.valoresBarraHorizontal)
        .text("A");
      var caja = texto.node().getBBox();
      altoVisualizacion =
        (caja.height + barras.distanciaVertical) * datos.opciones.length;
      var margin = config.getMargin();
      var gMargin = config.getGMargin();

      altoVisualizacion = _.max([altoVisualizacion, alturaAux]);

      altoVisualizacion +=
        margin.top + margin.bottom + gMargin.top + gMargin.bottom;
      svg.remove();
    }
  })();

  var config = new Config(altoVisualizacion, {
    top: 80,
    right: 10,
    bottom: 100,
    left: 200
  });

  var margin = config.getMargin();
  var medidas = config.getMedidas();

  var gMargin = config.getGMargin();
  var gMedidas = config.getGMedidas();

  var estilos = config.getEstilos();

  var contenedor = null;
  var svg = null;
  var gGrafica = null;
  var gReticula = null;
  var gEjeX = null;
  var gEjeY = null;
  var gBarras = null;
  var gLeyendas = null;

  var multiplicadorX = 3 / 5;
  var circulos = config.getCirculos();
  var grupos = null;

  var escalaX = d3.scale.linear().range([0, gMedidas.ancho * multiplicadorX]); //*0.8?
  var escalaY = d3.scale.ordinal().rangeRoundBands([gMedidas.alto, 0], 0.5);
  var escalaOpacidad = d3.scale.linear().range([0.3, 1]);

  var offsetIcono = 100;

  var ejeX = d3.svg
    .axis()
    .scale(escalaX)
    .orient("bottom")
    .ticks(10);

  var ejeY = d3.svg
    .axis()
    .scale(escalaY)
    .orient("left")
    .tickFormat(function(d) {
      var obj = _.find(datos.opciones, { opcion: d }) || false;
      return obj === false ? d : obj.etiqueta;
    });

  function setup() {
    contenedor = d3.select(el[0]);
    var flag = el.data("visualizacion") || false;
    if (flag === false) {
      el.data("visualizacion", true);
      contenedor.selectAll("svg").remove();
      svg = contenedor
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr(
          "viewBox",
          "0 0 " +
            (medidas.ancho + margin.left + margin.right) +
            " " +
            (medidas.alto + margin.top + margin.bottom)
        );

      el.attr("data-setup", true);

      if (debug === true) {
        svg
          .append("rect")
          .attr("fill", "yellow")
          .attr("opacity", 0.5)
          .attr("x", 0)
          .attr("y", 0)
          .attr("width", medidas.ancho + margin.left + margin.right)
          .attr("height", medidas.alto + margin.top + margin.bottom);
      }

      svg = svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (debug === true) {
        svg
          .attr("class", "svg")
          .append("rect")
          .attr("width", medidas.ancho + (margin.right - margin.left))
          .attr("height", medidas.alto)
          .attr("fill", "blue")
          .attr("opacity", 0.5);
      }

      gGrafica = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + gMargin.left + "," + gMargin.top + ")"
        );

      if (debug === true) {
        gGrafica
          .attr("class", "gGrafica")
          .append("rect")
          .attr("width", gMedidas.ancho)
          .attr("height", gMedidas.alto)
          .attr("fill", "red")
          .attr("opacity", 0.5);
      }

      gReticula = gGrafica.append("g");
      gEjeX = gGrafica
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + gMedidas.alto + ")");
      gEjeY = gGrafica.append("g").attr("class", "y axis");
      gBarras = gGrafica.append("g");
      gLeyendas = gGrafica.append("g");

      _.each(datos.opciones, function(o) {
        var valorpp = o.valorpp || false;
        var personas = o.personas || 0;
        if (valorpp !== false) {
          o.valor = valorpp;
          o.emisiones = valorpp;
          o.distancia = 1;
        }
        if (personas !== false) {
          o.personas = personas;
        }
      });
      var orden = el.data("orden") || false;
      if (orden !== false) {
        orden = orden.toLowerCase();
        switch (orden) {
          case "alfa":
            datos.opciones.sort(ordenAlfabetico);
            break;
          case "desc":
            datos.opciones.sort(ordenDescendente);
            break;
          default:
            break;
        }
      }
      main();
    }
  }

  function main() {
    setCirculos();
    setEscalas();
    setEjes();
    setLeyendas();
    funciones.generaTooltips(gGrafica.selectAll("path.transporte"));
    el.removeClass("espera");
    iniciar();
  }

  function revisaScroll() {
    if (el.visible(true) === true) {
      iniciar();
      $(window).off("scroll", revisaScroll);
    }
  }

  function iniciar() {
    actualizaCirculos();
    actualizaBarras();
    callback(null, true);
  }

  function actualizaCirculos() {
    grupos
      .append("text")
      .attr("x", 0)
      .attr("y", 0)
      .style(circulos.estiloTexto)
      .attr("opacity", 0)
      .text(function(d) {
        return parseInt(+d.valor / 1000) + "kg";
      })
      .transition()
      .duration(800)
      .attr("opacity", 1);
  }

  function setCirculos() {
    var x = gMedidas.ancho - (circulos.radio + circulos.offset);
    var yIni = circulos.radio;

    grupos = gGrafica
      .selectAll("g.circulo")
      .data(datos.extras, function(d) {
        return d.opcion;
      })
      .enter()
      .append("g")
      .attr("class", "circulo")
      .attr("transform", function(d, i) {
        return "translate(" + x + "," + (yIni + i * 4 * yIni) + ")";
      });

    grupos
      .append("circle")
      .attr("cx", 0)
      .attr("cy", 0)
      .attr("r", circulos.radio)
      .style(circulos.estiloCirculo);

    grupos
      .append("text")
      .style(circulos.estiloLeyenda)
      .attr("y", yIni + 20)
      .text(function(d) {
        return d.etiqueta;
      })
      .call(funciones.wrap, circulos.radio + circulos.offset);
  }

  function setEscalas() {
    var maxX = d3.max(datos.opciones, function(d) {
      return Math.ceil(+d.valor);
    });
    escalaX.domain([0, maxX]);
    escalaY.domain(
      datos.opciones.map(function(d) {
        return d.opcion;
      })
    );
    escalaOpacidad.domain([0, maxX]);
  }

  function setEjes() {
    var transportes = config.getTransportes();
    var ancho = 0;
    var escala = 1;
    var iconos = gEjeY.selectAll("path.transporte").data(datos.opciones);
    var textos = gEjeY.selectAll("text.transporte").data(datos.opciones);
    iconos
      .enter()
      .append("path")
      .attr("class", "transporte")
      .attr("d", function(d) {
        return d.ruta;
      })
      .attr("transform", "scale(" + escala + ")")
      .attr("fill", transportes.fondo)
      .each(function(d) {
        var caja = this.getBBox();
        d.caja = caja;
        ancho = _.max([ancho, (caja.width - caja.x) * escala]);
      });

    gEjeY.attr("transform", "translate(" + -(ancho + 10) + ",0)");

    iconos.attr("transform", function(d) {
      d.coordenadasIcono = {};
      d.coordenadasIcono.x =
        ancho - (d.caja.width + d.caja.x) * escala - offsetIcono;
      d.coordenadasIcono.y =
        escalaY(d.opcion) -
        d.caja.y * escala -
        (d.caja.height * escala - escalaY.rangeBand()) / 2;
      return (
        "translate(" +
        d.coordenadasIcono.x +
        "," +
        d.coordenadasIcono.y +
        ")scale(" +
        escala +
        ")"
      );
    });

    var estilosBH = config.getBarrasHorizontales();

    var aux = textos
      .enter()
      .append("text")
      .attr("class", "transporte")
      .style(estilosBH.leyendaEmisiones);

    aux
      .append("tspan")
      .text(function(d) {
        return d.personas;
      })
      .style("font-weight", "bold");
    aux.append("tspan").text(function(d) {
      return d.personas == 1 ? " persona" : " personas";
    });
    aux
      .append("tspan")
      .text(function(d) {
        return parseInt(d.distancia);
      })
      .style("font-weight", "bold")
      .attr("x", 0)
      .attr("dy", "1.1em");
    aux.append("tspan").text(" km");

    textos.attr("transform", function(d) {
      var caja = this.getBBox();
      var y = escalaY(d.opcion) - (caja.height - escalaY.rangeBand()) / 2;
      return "translate(" + -(offsetIcono - 100) + "," + y + ")";
    });

    gEjeX
      .style(estilos.eje)
      .call(ejeX)
      .selectAll("text")
      .remove();

    gEjeX
      .selectAll("line")
      .style(estilos.reticula)
      .attr("x1", 0)
      .attr("y1", 0)
      .attr("y2", -gMedidas.alto);
  }

  function actualizaBarras() {
    var unidad = el.data("unidad") || "";
    var barras = gBarras.selectAll("rect").data(datos.opciones, function(d) {
      return d.opcion;
    });
    var valores = gBarras.selectAll("text").data(datos.opciones, function(d) {
      return d.opcion;
    });

    barras
      .enter()
      .append("rect")
      .style(estilos.barra)
      .attr("opacity", function(d) {
        return escalaOpacidad(d.valor);
      })
      .attr("y", function(d) {
        return escalaY(d.opcion);
      })
      .attr("x", 0)
      .attr("height", escalaY.rangeBand())
      .attr("width", 0)
      .transition()
      .duration(800)
      .attr("width", function(d) {
        return escalaX(d.valor);
      });

    var decimales = el.data("decimales") || false;
    valores
      .enter()
      .append("text")
      .text(function(d) {
        var v = d.valor;
        if (decimales === false) {
          if (v < 1) {
            v = "0";
          } else {
            v = parseInt(v);
          }
        }
        return v + unidad;
      })
      .style(estilos.valoresBarraHorizontal)
      .style("font-weight", "bold")
      .attr("y", function(d) {
        return escalaY(d.opcion) + escalaY.rangeBand() / 2;
      })
      .attr("x", 6)
      .transition()
      .duration(800)
      .attr("x", function(d) {
        return escalaX(d.valor) + 6;
      });
  }

  function setLeyendas() {
    var titulo = datos.titulo || false;
    if (titulo !== false) {
      svg
        .append("text")
        .style(estilos.titulo)
        .attr("x", 0)
        .attr("y", margin.top)
        .text(titulo);
    }
    var leyendaX = el.data("leyenda-x") || false;
    if (leyendaX !== false) {
      svg
        .append("text")
        .style(estilos.leyendaEjeX)
        .attr("x", gMargin.left + 20)
        .attr("y", medidas.alto - 12)
        .text(leyendaX);
    }
    var leyendaY = el.data("leyenda-y") || false;
    if (leyendaY !== false) {
      var x = margin.left;
      var y = gMargin.top - 8;
      svg
        .append("text")
        .style(estilos.leyendaEjeY)
        .attr("x", x)
        .attr("y", y)
        .attr("transform", "rotate(-90," + x + "," + y + ")")
        .text(leyendaY);
    }
    var unidadPromedio = el.data("unidad-promedio") || false;
    if (unidadPromedio !== false) {
      var y = gMargin.top - 8;
      var suma = _.sumBy(datos.opciones, function(d) {
        return d.opcion * d.valor;
      });
      var promedio = parseInt(suma / +total);
      var textoUnidad = svg
        .append("text")
        .style(estilos.leyendaPromedioUnidad)
        .attr("x", medidas.ancho - gMargin.right)
        .attr("y", 12)
        .text(promedio + " " + unidadPromedio);
      var cajaTextoUnidad = textoUnidad.node().getBBox();
      svg
        .append("text")
        .style(estilos.leyendaPromedio)
        .attr("x", medidas.ancho - (gMargin.right + 20 + cajaTextoUnidad.width))
        .attr("y", 12)
        .text("Promedio: ");
    }
  }

  function ordenAlfabetico(a, b) {
    var aTxt = a.etiqueta.toUpperCase();
    var bTxt = b.etiqueta.toUpperCase();
    if (aTxt < bTxt) {
      return 1;
    }
    if (aTxt > bTxt) {
      return -1;
    }
    return 0;
  }

  function ordenDescendente(a, b) {
    var aValor = parseFloat(a.valor);
    var bValor = parseFloat(b.valor);
    var aTxt = a.etiqueta.toUpperCase();
    var bTxt = b.etiqueta.toUpperCase();
    if (aValor < bValor) {
      return -1;
    }
    if (aValor > bValor) {
      return 1;
    }

    if (a.personas < b.personas) {
      return -1;
    }
    if (a.personas > b.personas) {
      return 1;
    }

    if (a.distancia < b.distancia) {
      return -1;
    }
    if (a.distancia > b.distancia) {
      return 1;
    }

    if (aTxt < bTxt) {
      return 1;
    }
    if (aTxt > bTxt) {
      return -1;
    }
    return 0;
  }

  setup();
};
